

export const BETA_TAG_ANALYTICS = "tag-analytics";
// if available, contains the alternative tags for looking up data
export type BetaTagAnalyticsOverrides = "tag-analytics-overrides";
export const BETA_TAG_ANALYTICS_OVERRIDES: BetaTagAnalyticsOverrides = "tag-analytics-overrides";

export const BETA_RECOMENDATIONS = "recomendations";
export const BETA_NOTIFICATIONS = "notifications";
export const BETA_FLEET_MANAGEMENT = "fleet-management";

export const BETA_SEMANTIC_REQUEST_SEARCH = "semantic-request-search";
export const BETA_OVERVIEW_V2 = "overview-v2";
export const BETA_ORG_DASHBOARD = "org-dashboard";
export const BETA_MAP_VIEW = "map-view";

// Abandoned/partial lead functionality
export const BETA_ABANDONED_LEAD_CAPTURE = "enableAbandonedLeadCapture";
export const BETA_PARTIAL_LEAD_EMAILS = "enablePartialLeadEmails";